import React from 'react';
import { motion } from 'framer-motion';
export function CoffeeCupIllustration({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative flex justify-center items-center ${className}`} aria-hidden="true" data-id="element-9">
      <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-cream" data-id="element-10">
        {/* Cup Body */}
        <path d="M25 45C25 45 25 85 45 95C65 105 85 95 85 95C85 95 85 45 85 45" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-11" />

        {/* Cup Rim */}
        <ellipse cx="55" cy="45" rx="30" ry="8" stroke="currentColor" strokeWidth="4" data-id="element-12" />

        {/* Cup Handle */}
        <path d="M85 55C95 55 100 60 100 70C100 80 95 85 85 85" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-13" />

        {/* Saucer */}
        <path d="M15 100C15 100 35 110 55 110C75 110 95 100 95 100" stroke="currentColor" strokeWidth="4" strokeLinecap="round" data-id="element-14" />

        {/* Animated Steam Lines */}
        <motion.path d="M45 30C45 30 40 20 45 15C50 10 45 5 45 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: [0, 1, 1],
        opacity: [0, 0.6, 0],
        y: [0, -10, -15]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0
      }} data-id="element-15" />

        <motion.path d="M55 25C55 25 60 15 55 10C50 5 55 0 55 0" stroke="currentColor" strokeWidth="3" strokeLinecap="round" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: [0, 1, 1],
        opacity: [0, 0.8, 0],
        y: [0, -12, -18]
      }} transition={{
        duration: 3.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.8
      }} data-id="element-16" />

        <motion.path d="M65 30C65 30 60 20 65 15C70 10 65 5 65 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: [0, 1, 1],
        opacity: [0, 0.5, 0],
        y: [0, -8, -12]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1.5
      }} data-id="element-17" />
      </svg>
    </div>;
}